import {APP_INITIALIZER, NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";

import {environment} from "../environments/environment";
import {NgxsModule} from "@ngxs/store";
import {AppState} from "./state";
import {ProductState, ProductApiStatusState} from "./components/product/state";
import {
    MSAL_GUARD_CONFIG,
    MSAL_INSTANCE,
    MsalBroadcastService,
    MsalGuard,
    MsalRedirectComponent,
    MsalService
} from "@azure/msal-angular";
import {MSALGuardConfigFactory, MSALInstanceFactory} from "./services";
import {HttpErrorInterceptor} from "./interceptors/http-error-interceptor.interceptor";
import {ToolbarComponent} from './components/main';
import {CommonModule, DATE_PIPE_DEFAULT_OPTIONS, registerLocaleData} from "@angular/common";
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import {MatMenuModule} from "@angular/material/menu";
import {RouterLink, RouterOutlet} from "@angular/router";
import {MatToolbarModule} from "@angular/material/toolbar";
import {AppRoutingModule} from "./app-routing.module";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatTooltipModule} from "@angular/material/tooltip";
import {ApiModule, BASE_PATH} from './services/api';
import * as Sentry from "@sentry/angular";
import {ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";


registerLocaleData(localeDe);
registerLocaleData(localeEn);

@NgModule({
    declarations: [
        AppComponent,
        ToolbarComponent,
    ],
    bootstrap: [AppComponent, MsalRedirectComponent],
    imports: [
        NgxsModule.forRoot([AppState, ProductState, ProductApiStatusState], {developmentMode: true}),
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        ApiModule,
        MatIconModule,
        MatTooltipModule,
        MatButtonModule,
        CommonModule,
        MatMenuModule,
        RouterLink,
        MatToolbarModule,
        RouterOutlet,
    ], providers: [
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        // {
        //     provide: LOCALE_ID,
        //     useValue: 'de-DE'
        // },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler(),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => {},
            deps: [Sentry.TraceService],
            multi: true,
        },
        {
            provide: DATE_PIPE_DEFAULT_OPTIONS,
            useValue: {dateFormat: 'yyyy-MM-dd HH:mm'},
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory
        },
        {provide: BASE_PATH, useValue: environment.apiIp},
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule {
    constructor(trace: Sentry.TraceService) {}
}
